<template>
  <div class="page-mini-index">
    <div class="cell-container"
         v-for="(list, index) in cellData"
         :key="'cell-' + index"
    >
      <ym-cell class="cell-container-list"
               :title="item.title"
               v-for="(item, itemKey) in list"
               :key="'item-' + itemKey"
               is-link
               :to="{ name: item.name }"
      >
        <template #icon>
          <ym-icon class="ym-cell-icon"
                   :class="`my-${item.icon}`"
                   :name="item.icon"
          />
        </template>
      </ym-cell>
    </div>
  </div>
</template>

<script>
  import { Cell } from '@ymba/ym-ui';

  export default {
    name: 'PageMiniIndex',
    components: {
      'ym-cell': Cell,
    },
    data() {
      return {
        cellData: [
          [{
            name: 'Feedback',
            title: '意见反馈',
            icon: 'feedback',
          }, {
            name: 'SystemSetting',
            title: '设置',
            icon: 'setting',
          }],
        ],
      };
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';
  .cell-container {
    margin: @size-base @size-base 0;
    border-radius: @border-radius-medium;
    background: @color-white;
    overflow: hidden;
  }

  .ym-cell-icon {
    width: @my-cell-icon-size;
    height: @my-cell-icon-size;
    margin-right: @size-extra-small;
    vertical-align: middle;
    color: @color-text-lighter;
    font-size: @font-size-large;
  }
</style>
